export const template3PlaceholderData = [
  {
    id: 1,
    name: 'Menu 1',
    categories: [
      {
        id: 1,
        name: 'burgers and sandwisches',
        items: [
          {
            id: 1,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
            outOfStock: true,
            modifiers: {},
          },
          {
            id: 2,
            itemName: 'New York Cheesecake',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 3,
            itemName: 'Churros',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 4,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 5,
            itemName: 'New York Cheesecake',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 6,
            itemName: 'Churros',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 7,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 8,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 9,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 10,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 11,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 12,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 13,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 14,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 15,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
        ],
      },
      {
        id: 2,
        name: 'Teas & More',
        items: [
          {
            id: 16,
            itemName: 'Bean And Cheese And Rice Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
            outOfStock: true,
            modifiers: {},
          },
          {
            id: 17,
            itemName: 'New York Cheesecake',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 18,
            itemName: 'Churros',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 19,
            itemName: 'Chocolate Fudge Brownie',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 20,
            itemName: 'New York Cheesecake',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 21,
            itemName: 'Churros',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 22,
            itemName: 'New York Cheesecake',
            itemDescription: 'Classic cheesecake topped with strawberry sauce.',
            itemPrice: '20.99',
          },
          {
            id: 23,
            itemName: 'Margherita Pizza',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 24,
            itemName: 'Pepperoni Blast',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 25,
            itemName: 'Iced Latte',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 26,
            itemName: 'Iced Latte',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 27,
            itemName: 'Iced Latte',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 28,
            itemName: 'Iced Latte',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
        ],
      },
      {
        id: 3,
        name: 'Snacks',
        items: [
          {
            id: 29,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
            modifiers: {},
          },
          {
            id: 30,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 31,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 32,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 33,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 34,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 35,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 36,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 37,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 38,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 39,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 40,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 41,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 42,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
          {
            id: 43,
            itemName: 'Breakfast Burrito',
            itemDescription:
              'A medley of zucchini, peppers, and mushrooms with black beans. Finished with smoky chipotle aioli for a burst of flavor.',
            itemPrice: '20.99',
          },
        ],
      },
    ],
  },
];
